import { CONFIG } from './config'

/** Escape special regex characters in a string */
export const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Reset file input value after use */
export const resetFileInput = (e) => e?.target && (e.target.value = '')

/** Download content as a file */
export const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/** Find word boundaries at cursor position */
export const getWordAtPosition = (text, position) => {
  if (!text || position < 0 || position > text.length) return null

  let start = position
  while (start > 0 && !/\s/.test(text[start - 1])) start--

  let end = position
  while (end < text.length && !/\s/.test(text[end])) end++

  const word = text.slice(start, end).trim()
  return word ? { word, start, end } : null
}

/** Check if string is a valid token */
export const isToken = (str) => CONFIG.token.patternExact.test(str)

/** Find highest token number in text to avoid duplicates */
export const getMaxTokenNumber = (text) => {
  if (!text) return 0
  const tokens = text.match(CONFIG.token.patternGlobal) || []
  return tokens.reduce((max, token) => {
    const num = parseInt(token.replace('xxxxx', ''), 10)
    return num > max ? num : max
  }, 0)
}

/** Set page meta tags for SEO: title, description, canonical, OG, Twitter */
export const setPageMeta = ({ title, description, canonical }) => {
  document.title = title

  const setAttr = (selector, attr, value) => {
    const el = document.querySelector(selector)
    if (el) el.setAttribute(attr, value)
  }

  setAttr('meta[name="description"]', 'content', description)
  setAttr('link[rel="canonical"]', 'href', canonical)
  setAttr('meta[property="og:title"]', 'content', title)
  setAttr('meta[property="og:description"]', 'content', description)
  setAttr('meta[property="og:url"]', 'content', canonical)
  setAttr('meta[name="twitter:title"]', 'content', title)
  setAttr('meta[name="twitter:description"]', 'content', description)
  setAttr('meta[name="twitter:url"]', 'content', canonical)
}

/** Validate redaction map structure and security */
export const validateRedactionMap = (parsed) => {
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    throw new Error('Invalid format: must be an object')
  }

  // Prevent prototype pollution
  const dangerous = ['__proto__', 'constructor', 'prototype']
  if (dangerous.some((key) => Object.prototype.hasOwnProperty.call(parsed, key))) {
    throw new Error('Invalid key: contains dangerous property')
  }

  const entries = Object.entries(parsed)
  if (entries.length === 0) {
    throw new Error('Key file is empty')
  }

  for (const [token, original] of entries) {
    if (!isToken(token)) {
      throw new Error(`Invalid token format: ${token}`)
    }
    if (typeof original !== 'string' || original.trim().length === 0) {
      throw new Error(`Invalid value for ${token}: must be a non-empty string`)
    }
  }

  return parsed
}
